<template>
  <div class="container">
    <b-row>
      <b-col md="4">
        <b-card>
          <b-card-body>
            <b-form>
              <h1>Alterar senha</h1>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa-solid fa-unlock" aria-hidden="true"></i
                  ></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="currentPassword"
                  type="password"
                  class="form-control"
                  placeholder="Senha Atual"
                  @keyup.native="checkSubmit"
                >
                </b-form-input>
              </b-input-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa-solid fa-unlock" aria-hidden="true"></i
                  ></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  id="password"
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Nova Senha"
                  @keyup="checkStrength"
                  @keyup.native="checkSubmit"
                >
                </b-form-input>
              </b-input-group>
              <b-input-group class="mb-1">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa-solid fa-unlock" aria-hidden="true"></i
                  ></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="confirmPassword"
                  type="password"
                  class="form-control"
                  placeholder="Confirmar Senha"
                  @keyup.native="checkSubmit"
                >
                </b-form-input>
              </b-input-group>
              <b-progress
                :value="passwordScore"
                max="4"
                class="mb-1"
                animated
                :variant="scoreVariant"
              />
              <b-row v-if="pwdErrors" class="mb-2">
                <b-col cols="12">
                  <span class="text-danger">{{ pwdErrors }}</span>
                </b-col>
              </b-row>
              <b-popover
                target="password"
                triggers="manual blur"
                placement="top"
              >
                <template #title>Sugestões</template>
                <span>
                  <template v-for="(suggestion, idx) in suggestions">
                    <span :key="suggestion">
                      {{ suggestion }}<br v-if="idx > 0" />
                    </span>
                  </template>
                </span>
              </b-popover>
              <b-row>
                <b-col cols="12">
                  <b-button
                    variant="primary"
                    :disabled="loading || passwordScore < 3"
                    class="px-4"
                    @click="handleSubmit"
                    >Alterar
                  </b-button>
                  <b-button
                    :disabled="loading"
                    class="px-4 float-right"
                    @click="handleCancel"
                    >Cancelar</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import sha256 from "js-sha256";
import { changePassword } from "@/api/user";
import zxcvbn from "zxcvbn";
import messages from "@/i18n/zxcvbn.json";

export default {
  name: "ChangePassword",
  props: {
    hash: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pwdErrors: "",
      suggestions: [],
      currentPassword: "",
      password: "",
      confirmPassword: "",
      loading: false,
      passwordScore: 0,
    };
  },
  computed: {
    scoreVariant() {
      switch (this.passwordScore) {
        case 4:
        case 3:
          return "success";
        case 2:
          return "warning";
        default:
          return "danger";
      }
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        await changePassword(
          sha256(this.currentPassword),
          sha256(this.password)
        );
        this.loading = false;
        this.$bvToast.toast("Senha alterada com sucesso", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
        this.$router.push({ path: "/" });
      } catch (error) {
        this.loading = false;
        if (parseInt(error.response.status / 100) === 4) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
    checkSubmit(e) {
      if (e.key === "Enter") {
        this.handleSubmit();
      }
    },

    checkStrength() {
      const result = zxcvbn(this.password);
      this.passwordScore = result.score;
      this.pwdErrors = messages[result?.feedback?.warning] || "";
      const suggestions = [];
      for (const suggestion of result?.feedback?.suggestions || []) {
        suggestions.push(messages[suggestion]);
      }
      this.suggestions = suggestions;
      if (this.suggestions.length > 0 && this.password) {
        this.$root.$emit("bv::show::popover");
      }
    },

    handleCancel() {
      this.$router.go(-1);
    },

    async handleSubmit() {
      this.pwdErrors = "";

      if (this.currentPassword.length === 0) {
        this.pwdErrors = "Preencha os campos";
        return;
      } else if (this.password !== this.confirmPassword) {
        this.pwdErrors = "As senhas não conferem";
        return;
      }
      await this.submit();
    },
  },
};
</script>
